import _ from 'lodash';
import constants from './constants';

export const applyDrag = (arr, dragResult) => {
  const {
    removedIndex, addedIndex, payload, columnId,
  } = dragResult;

  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];
  let itemToAdd = payload;

  // сортировка внутри одной колонки
  let newIndex;
  let fullIndexing = false;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);

    const prevElem = result[addedIndex - 1];
    const nextElem = result[addedIndex + 1];

    // вставили в середину и есть позиции

    if (addedIndex === 0 && nextElem && nextElem.position) {
      newIndex = nextElem.position / 2;
    } else if (addedIndex + 1 === result.length && prevElem && prevElem.position) {
      newIndex = parseInt(prevElem.position, 10) + 1;
    } else if (prevElem && nextElem && prevElem.position && nextElem.position) {
      newIndex = (prevElem.position + nextElem.position) / 2;
    } else if (prevElem && nextElem && prevElem.position && nextElem && !nextElem.position) {
      newIndex = parseInt(prevElem.position, 10) + 1;
    } else if ((prevElem && nextElem && !prevElem.position && !nextElem.position) || (prevElem && !prevElem.position && addedIndex + 1 === result.length)) {
      fullIndexing = true;
    } else {
      fullIndexing = true;
    }

    if (fullIndexing) {
      for (let i = 0; i < result.length; i++) {
        // делаем порядок начиная с 1
        result[i].position = i + 1;
      }
    } else if (!fullIndexing && addedIndex !== undefined) {
      result[addedIndex].position = newIndex;
    }
  }

  return { updated: result, fullIndexing };
};

export const compareTasks = ({ key, direction, resources = [], wbsCodesMap = {} }) => (prev, next) => {
  let result = 0;

  switch (key) {
  case 'status':
    result = prev.status - next.status;
    break;
  case 'priority':
    result = prev.priority - next.priority;
    break;
  case 'name':
    result = prev.text.localeCompare(next.text);
    break;
  case 'wbs':
    result = prev.wbsCode > next.wbsCode ? 1 : -1;
    break;
  case 'resources':
    const prevRes = resources.find(r => r.id === prev.resources[0]?.resource_id)?.name;
    const nextRes = resources.find(r => r.id === next.resources[0]?.resource_id)?.name;

    if (!nextRes && !prevRes) {
      result = 0;
    }

    if (!prevRes) {
      result = 1;
    }

    result = prevRes > nextRes ? 1 : prevRes === nextRes ? 0 : -1;
    break;
  case 'startDate':
    const prevStart = +prev.start_date;
    const nextStart = +next.start_date;

    result = prevStart > nextStart ? 1 : prevStart === nextStart ? 0 : -1;
    break;
  case 'endDate':
    const prevEnd = +prev.end_date;
    const nextEnd = +next.end_date;

    result = prevEnd > nextEnd ? 1 : prevEnd === nextEnd ? 0 : -1;
    break;
  case 'custom':
    result = prev.position - next.position;
    break;
  case 'createDate':
  default:
    const prevCreated = +(new Date(prev.created_at));
    const nextCreated = +(new Date(next.created_at));

    result = prevCreated > nextCreated ? 1 : prevCreated === nextCreated ? 0 : -1;
    break;
  }

  return result * (direction === 'DESC' ? -1 : 1);
};

export const taskToOptions = ({ task, groupingFieldInfo }) => {
  const opts = [];

  if (groupingFieldInfo.key === 'resources' && !groupingFieldInfo.isCustom) {
    if (!task[groupingFieldInfo.key].length) {
      opts.push(constants.COMMON_EMPTY);
    } else {
      task[groupingFieldInfo.key].forEach(resource => {
        opts.push(resource.resource_id);
      });
    }
  } else if (groupingFieldInfo.isCustom) {
    const customVal = task[groupingFieldInfo.customFieldId];

    if (!customVal.length) {
      opts.push(constants.COMMON_EMPTY);
    } else {
      opts.push(...customVal);
    }
  } else {
    opts.push(task[groupingFieldInfo.key]);
  }

  return opts;
};

export const changeAssign = ({ task, rawValue, $store }) => {
  const changedResources = [];

  if (rawValue.includes(constants.COMMON_EMPTY)) {
    changedResources.push(...task.resources.map(res => ({
      resource_id: res.resource_id,
      // userId: res.userId,
      action: 'delete',
    })));
  } else {
    let value = task.estimation || task.duration / 60;

    if (Array.isArray(rawValue)) {
      changedResources.push(...task.resources.map(res => ({
        resource_id: res.resource_id,
        // userId: res.userId,
        action: 'delete',
      })));

      let perHourResourcesCount = 0;
      const projectResources = $store.getters['resourcesModel/getResourcesByProjectIdForUI'](task.gantt_id)
        .reduce((acc, res) => {
          if (rawValue.includes(res.id)) {
            acc[res.id] = res;

            if (res.type === 1) {
              perHourResourcesCount++;
            }
          }

          return acc;
        }, {});

      rawValue.forEach(id => {
        let newResourceValue = 0;

        const existingTaskResource = task.resources.find(res => res.resource_id === id);

        if (existingTaskResource && projectResources[id].type !== 1) {
          newResourceValue = existingTaskResource.value;
        } else {
          newResourceValue = projectResources[id].type === 1 && perHourResourcesCount ? value / perHourResourcesCount : 0;
        }

        changedResources.push({
          resource_id: id,
          // userId: projectResources[id].userId,
          action: 'insert',
          value: newResourceValue,
        });
      });
    } else {
      if (task.resources.length) {
        value = task.resources.find(res => res.resource_id === task.columnId).value;
        changedResources.push({
          resource_id: task.columnId,
          // userId: $store.getters['resourcesModel/getResourceById'](task.columnId).userId,
          action: 'delete',
        });
      }

      if (!task.resources.find(res => res.resource_id === rawValue)) {
        changedResources.push({
          resource_id: rawValue,
          // userId: $store.getters['resourcesModel/getResourceById'](rawValue).userId,
          action: 'insert',
          value,
        });
      }
    }
  }

  $store.dispatch('tasksModel/updateTasks', {
    tasks: [{ id: task.id, changedResources }],
    sourceEvent: {
      type: constants.GANTT_SOURCE_EVENT_TYPES.TASK_RESOURCES_UPDATE,
      sourceId: +task.id,
    },
    fromGantt: false,
  });
};

export const prepareTaskValue = ({
  task, key, rawValue, field,
}) => {
  let value = '';

  if (['status', 'priority'].includes(key)) {
    value = rawValue;
  }

  if (field.isCustom) {
    if (field.type === 'select' && rawValue !== constants.COMMON_EMPTY) {
      value = `${rawValue}`;
    }

    if (field.type === 'multiselect') {
      if (!task[key]) {
        value = `${rawValue}`;
      } else if (Array.isArray(rawValue)) {
        if (!rawValue.includes(constants.COMMON_EMPTY)) {
          value = rawValue.join(',');
        }
      } else if (rawValue !== constants.COMMON_EMPTY) {
        value = task[key].filter(optId => optId !== task.columnId);
        if (!value.includes(rawValue)) {
          value.push(rawValue);
        }
        value = value.join(',');
      }
    }
  }

  return value;
};

export const prepareField = ({ field, projectResources, isJiraProject }) => {
  if (['status', 'priority'].includes(field.key)) {
    const options = field.options.map(opt => {
      const headerColor = constants.BOARD.COLORS[`${field.key}_${opt.value}`].header;
      const color = constants.BOARD.COLORS[`${field.key}_${opt.value}`].dropdown;
      const icon = constants.BOARD.ICONS[`${field.key}_${opt.value}`];

      return {
        ...opt,
        headerColor,
        color,
        icon,
        value: field.key === 'priority' ? __(`filter_${field.key}_${opt.value}`) : __(`board_${field.key}_${opt.value}`),
      };
    });

    return { ...field, options };
  }

  if (field.key === 'tags') {
    const options = field.options.map(opt => {
      const headerColor = opt.color;
      const headerLabelColor = '#FFFFFF';

      return {
        ...opt,
        headerColor,
        headerLabelColor,
      };
    });

    return { ...field, options };
  }

  if (field.key === 'color' && field.isCustom) {
    const options = field.options.map(opt => {
      const headerColor = opt.value;

      return {
        ...opt,
        headerColor,
        noLabel: true,
      };
    });

    return { ...field, options };
  }

  if (['select', 'multiselect'].includes(field.key)) {
    const options = field.options.map(opt => {
      const headerColor = '#E5E5E5';

      return {
        ...opt,
        headerColor,
      };
    });

    return { ...field, options };
  }

  if (field.key !== 'resources') return field;

  let options = [];

  const resources = isJiraProject ? projectResources.filter(i => !i.userId) : projectResources;

  if (field.isCustom) {
    options = field.options.map(opt => {
      const projectResource = resources.find(resource => resource.id == opt.value);

      if (!projectResource) return null;

      const { value, picture } = projectResource; 

      return { ...opt, resourceId: projectResource.id, value, picture };
    }).filter(item => item);
  } else {
    options = resources.map(res => ({ ...res, resourceId: res.id }));
  }

  return {
    ...field,
    options,
  };
};

export const prepareFieldOptions = ({ field, order }) => {
  const newOptions = field?.options?.length ? [...field.options] : [];

  if (field.key && !['status', 'priority'].includes(field.key)) {
    let emptyValue = '';

    switch (field.key) {
    case 'resources':
      if (field.isCustom) {
        emptyValue = __('board_column_no_value');
      } else {
        emptyValue = __('board_column_unassigned');
      }
      break;
    case 'tags':
      emptyValue = __('board_column_no_value');
      break;
    case 'multiselect':
      emptyValue = __('board_column_no_value');
      break;
    case 'select':
      emptyValue = __('board_column_no_value');
      break;
    case 'color':
      emptyValue = __('board_column_no_value');
      break;
    }

    newOptions.unshift({
      id: constants.COMMON_EMPTY,
      value: emptyValue,
      sortOrder: -1
    });
  }

  if (order.length) {
    const customOrderMap = order.reduce((acc, item) => {
      acc[item.id] = item.order;

      return acc;
    }, {});

    newOptions.sort((prev, next) => {
      if (!customOrderMap[prev.id]) return 1;
      if (!customOrderMap[next.id]) return -1;

      return customOrderMap[prev.id] - customOrderMap[next.id];
    });
  } else {
    newOptions.sort((prev, next) => {
      if (isNaN(+prev.sortOrder)) return 1;
      if (isNaN(+next.sortOrder)) return -1;

      return prev.sortOrder - next.sortOrder;
    });
  }

  return newOptions;
};

export const getWorkloadUnitLocale = ({ workloadType }) => {
  let result = '';

  switch (workloadType) {
    case constants.RESOURCE_TIME_TYPE:
      result += 'resource_time_type';
      break;
    case constants.RESOURCE_ITEM_TYPE:
      result += 'resource_item_type';
      break;
    case constants.RESOURCE_COST_TYPE:
      result += 'resource_cost_type';
      break;
  }

  return result;
};

export const mapByValuableFields = ({ task, groupingFieldInfo, sortingFieldInfo, currentFilter }) => {
  let groupingTaskKey = '';

  if (groupingFieldInfo.isCustom) {
    groupingTaskKey = groupingFieldInfo.customFieldId;
  } else {
    groupingTaskKey = groupingFieldInfo.key;
  }

  const sortingFieldKey = sortingFieldInfo.key;
  let sortingTaskKey = '';

  switch (sortingFieldKey) {
    case 'status':
    case 'priority':
    case 'resources':
      sortingTaskKey = sortingFieldKey;
      break;
    case 'name':
      sortingTaskKey = 'text';
      break;
    case 'startDate':
      sortingTaskKey = 'start_date';
      break;
    case 'endDate':
      sortingTaskKey = 'end_date';
      break;
    default:
      sortingTaskKey = 'created_at';
      break;
  }

  const result = {
    id: task.id,
    [groupingTaskKey]: task[groupingTaskKey],
    [sortingTaskKey]: task[sortingTaskKey],
  };

  if (currentFilter) {
    Object.keys(currentFilter.properties).forEach((key) => {
      if (!_.isEmpty(currentFilter.properties[key])) {
        switch (key) {
          case 'color':
          case 'priority':
          case 'status':
          case 'text':
            result[key] = task[key];
            break;
          case 'overdue':
            result.overdue = new Date(task.end_date) < new Date() && task.progress < 1 && task.type === 'task';
            break;
          case 'assignee':
            result.resources = task.resources;
            break;
          case 'endDate':
            result.end_date = task.end_date;
            break;
          case 'startDate':
            result.start_date = task.start_date;
            break;
        }
      }
    });
  }

  return result;
};

export const getTaskBreadcrumbs = ({ parentId, tasksMap }) => {
  if (!parentId) return;

  const result = [];

  while (parentId) {
    const parentData = tasksMap[parentId];

    parentId = parentData && parentData.parent;
    parentId && (parentId !== 1) && result.push(parentData.text);
  }

  const all = result.reverse();

  const delimeters = [];

  if (all.length === 2) {
    delimeters.push('/');
  } else if (all.length > 2) {
    delimeters.push('/', '...', '/');
  }

  const shortened = [...all];

  shortened.splice(1, all.length - 2, ...delimeters);

  return {
    all,
    shortened,
  };
};

export const outputPriority = id => {
  switch (id) {
  case 9:
    return 1;
  case 8:
    return 2;
  case 7:
    return 3;
  case 6:
    return 4;
  case 5:
    return 5;
  }
};

export const debounce = (func, timeout) => {
  let timer;

  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
};

export const mapTaskForBoard = ({
  task,
  visibleOnBoard = false,
  projectResources = {},
  customFields = [],
  customValues = {},
  wbsCode = ''
}) => {
  const {
    id,
    text,
    parent,
    gantt_id,
    type,
    color,
    status,
    priority,
    progress,
    created_at,
    owner_id,
    start_date,
    end_date,
    resources,
    hasComments,
    newComments,
    hasAttachments,
    duration,
    estimation,
  } = task;

  const preparedTask = {
    id,
    text,
    parent,
    gantt_id,
    type,
    color,
    status,
    priority,
    progress,
    created_at,
    owner_id,
    start_date,
    end_date,
    resources,
    hasComments,
    newComments,
    hasAttachments,
    wbsCode,
    duration,
    estimation,
  };

  if (!visibleOnBoard) return preparedTask;

  const taskResources = [];

  resources.forEach((res) => {
    const { resource_id } = res;

    const storeRes = projectResources[resource_id];

    if (!storeRes) return;

    taskResources.push(res);
  });

  preparedTask.resources = taskResources;

  customFields.forEach((field) => {
    const values = customValues[`${task.id}-${field.customFieldId}`] || customValues[field.customFieldId];

    let preparedValues = (!values ? [] : (values.length ? values : [values])); //.filter((val) => field.options.find((opt) => opt.id === val));

    preparedTask[field.customFieldId] = preparedValues.filter((val) => field.options.find((opt) => opt.id === val));
  });

  return preparedTask;
};

export const mapTaskForSharedBoard = ({
  task,
  visibleOnBoard = false,
  tasksMap = {},
  projectResources = {},
  customFields = [],
  customValues = {},
  wbsCode = '',
  colors = [],
  groupingField = {},
  statusField = {},
  priorityField = {},
  dateHelper
}) => {
  const mappedTask = mapTaskForBoard({
    task,
    visibleOnBoard,
    projectResources,
    customFields,
    customValues,
    wbsCode,
  });

  mappedTask.sharedView = true;

  if (!visibleOnBoard) return mappedTask;

  mappedTask.breadcrumbs = getTaskBreadcrumbs({
    parentId: mappedTask.parent,
    tasksMap
  });

  mappedTask.hexColor = colors.find(color => color.id === +mappedTask.color)?.hex || '#ffffff';

  mappedTask.showStatus = groupingField.key !== 'status';
  mappedTask.statusOption = statusField.options.find(opt => opt.id === mappedTask.status);
  mappedTask.showPriority = groupingField.key !== 'priority';
  mappedTask.priorityOption = priorityField.options.find(opt => opt.id === mappedTask.priority);
  mappedTask.resources = mappedTask.resources.map(({ resource_id, value }) => {
    const projectRes = projectResources[resource_id];
    const workloadType = projectRes.resourceProjects.find(p => p.projectId === mappedTask.gantt_id)?.type;

    return {
      resource_id,
      userId: projectRes.userId,
      name: projectRes.name,
      avatar: projectRes.photo || projectRes.resourcePhoto || `${GT.cdn}/imgs/default/default-ava.svg`,
      workload: value,
      workloadType,
      workloadUnit: workloadType ? __(getWorkloadUnitLocale({ workloadType })) : '',
    };
  });

  ['start_date', 'end_date'].forEach(key => {
    const formattedKey = `formatted${key.includes('start') ? 'StartDate' : 'EndDate' }`
    let format = dateHelper.getDateFormat();

    mappedTask[formattedKey] = webix.Date.dateToStr(format)(mappedTask[key]);
  }); 

  return mappedTask;
};
